import React from "react";
import PropTypes from "prop-types";
import { Scope } from "informed";

import { NavBar, Page } from ".";

const Pages = ({ themeData, scope }) => {
	let content = null;
	switch (scope) {
		case "navBar":
			content = <NavBar />;
			break;
		case "page":
			content = <Page />;
			break;
		default:
			break;
	}

	return <Scope scope={scope}>{content}</Scope>;
};

Pages.propTypes = {
	themeData: PropTypes.object.isRequired,
	scope: PropTypes.string.isRequired,
};

export default Pages;
